<template>
    <div class="pages" :class="{ 'is-h5': isH5 }">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box" :class="{ 'is-h5': isH5 }">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('通知') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="box-tit">
                <div class="align-center">
                    <i class="el-icon-arrow-left text-22 text-weight pointer margin-right-8" v-if="!is_list"
                        @click="onBack"></i>
                    <p class="">{{ $t('通知') }}</p>
                </div>
                <div class="box-tit-right pointer" @click="onRead">
                    <img src="../../../static/images/icon/icon31.png" alt="">
                    <span>{{ $t('一键已读') }}</span>
                </div>
            </div>

            <div class="list" v-if="is_list">
                <div class="list-box" v-for="(item, index) in list" :key="index" v-if="showNotificationType(index)" @click="onInform(index)">
                    <div class="list-box-l">
                        <img :src="item.img" alt="">
                        <div class="list-box-l-tag" v-if="item.num">{{ item.num }}</div>
                    </div>
                    <div class="list-box-c">
                        <p class="text-18 text-weight-600">{{ item.tit }}</p>
                        <p class="text-14 text-999">{{ item.txt }}</p>
                    </div>
                    <div class="list-box-time text-14 text-999">{{ item.time }}</div>
                </div>
            </div>

            <div class="list" v-else>
                <div v-if="list_index == 0">
                    <div class="list-box justify-between" v-for="(item, index) in announcement_list" :key="index">
                        <div class="list-box-c">
                            <p class="text-18 text-weight-600">{{ item.title }}</p>
                            <p class="text-14 text-999">{{ item.desc }}</p>
                        </div>
                        <div class="list-box-time text-14 text-999">{{ item.create_time }}</div>
                    </div>
                </div>

                <div v-else>
                    <div class="list-box justify-between" v-for="(item, index) in information_list" :key="index">
                        <div class="list-box-c">
                            <p class="text-18 text-weight-600">{{ item.title }}</p>
                            <p class="text-14 text-999">{{ item.content }}</p>
                        </div>
                        <div class="list-box-time text-14 text-999">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
import ShortcutBar from '@/components/ShortcutBar';
import leftSuspension from "@/components/leftSuspension.vue";
import { announcementList, informationList, informationCorner, read } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
    name: 'briefIntroduction',
    components: {
        'footer-bar': footerBar,
        'shortcut-bar': ShortcutBar,
        leftSuspension,
    },
    data() {
        return {
            list: [{
                img: require('../../../static/images/icon/icon29.png'),
                tit: this.$t('平台公告'),
                txt: '',
                time: '',
                num: 0
            }, {
                img: require('../../../static/images/icon/icon30.png'),
                tit: this.$t('系统公告'),
                txt: '',
                time: '',
                num: 0
            }],
            information_list: [],//消息列表
            announcement_list: [],//公告列表
            is_list: true,//是否为列表
            list_index: 0,//展示的列表
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
        }
    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        this.onAnnouncementList()
        this.onInformationList()
        this.onCorner()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
    },
    methods: {
        /** 公告类型没有内容时，隐藏对应入口 */
        showNotificationType(index) {
            return index === 0 ? this.announcement_list.length > 0 : this.information_list.length > 0;
        },
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**消息角标 */
        onCorner() {
            informationCorner().then(res => {
                // console.log(res.data);`
                this.list[0].num = res.data.notice
            })
        },
        /**一键已读 */
        onRead() {
            let type = 0
            if (this.is_list) {
                type = 0
            } else {
                if (this.list_index == 0) {
                    type = 1
                } else {
                    type = 2
                }
            }
            /**
             * type 1平台公告 2系统通知 0全部
             */

            read({ type: type }).then(res => {
                if (res.code == 1) {
                    this.$message.success(this.$t('公告已读'));
                    this.onAnnouncementList()
                    this.onInformationList()
                    this.onCorner()
                }
            })
        },
        /**返回列表 */
        onBack() {
            this.is_list = true
        },
        /**通知 */
        onInform(i) {
            console.log(i);
            this.list_index = i
            this.is_list = false
        },
        /**消息列表 */
        onInformationList() {
            informationList().then(res => {
                const informationData = Array.isArray(res.data.data) ? res.data.data : []
                this.information_list = informationData
                // console.log(this.information_list);

                if (!informationData.length) {
                    return
                }

                let data = informationData[0]
                this.list[1].txt = data.title
                this.list[1].time = data.create_time
            })
        },
        /**公告列表 */
        onAnnouncementList() {
            announcementList().then(res => {
                const announcementData = Array.isArray(res.data.data) ? res.data.data : []
                this.announcement_list = announcementData
                // console.log(this.announcement_list);
                if (!announcementData.length) {
                    return
                }

                let data = announcementData[0]
                this.list[0].txt = data.desc
                this.list[0].time = data.create_time
            })
        }
    }
};
</script>

<style scoped lang="scss">
.pages {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

.box {
    padding: 0 var(--page-gutter-wide) 80px;
    min-height: 80vh;
    flex: 1;
}

/* PC 端通知内容区与简介页保持一致，固定使用 1024px 页面栅格。 */
@media (min-width: 768px) {
    .box {
        width: 1024px;
        margin: 0 auto;
        padding: 0 0 80px;
        box-sizing: border-box;
    }
}

/*面包屑*/
.boxBreadcrumb {
    padding: 26px 0 32px 0;
}

/**标题 */
.box-tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    p {
        font-size: 24px;
        font-weight: 600;
    }

    .box-tit-right {
        display: flex;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
        }

        span {
            font-size: 16px;
        }
    }
}

/**列表 */
.list {
    .list-box {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        background: #F8F8F8;
        border-radius: 8px;
        margin-bottom: 16px;
        display: flex;
        cursor: pointer;

        .list-box-l {
            position: relative;
            flex-shrink: 0;

            img {
                width: 48px;
                height: 48px;
                display: block;
            }

            .list-box-l-tag {
                position: absolute;
                background: #FF0000;
                color: #FFFFFF;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                border-radius: 50%;
                font-size: 12px;
                top: 0;
                right: 0;
            }
        }

        .list-box-c {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0 12px;
            width: calc(100% - 222px);
        }
    }
}

@media (max-width: 767px) {
    .pages.is-h5 {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .pc-float {
        display: none;
    }

    .box.is-h5 {
        padding: 0 12px 24px;
        min-height: auto;

        .boxBreadcrumb {
            padding: 10px 0 12px;
            overflow-x: auto;
            white-space: nowrap;
            font-size: 12px;
        }

        .box-tit {
            margin-bottom: 12px;
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            box-sizing: border-box;

            p {
                font-size: 18px;
            }

            .box-tit-right {
                span {
                    font-size: 13px;
                }

                img {
                    width: 18px;
                    height: 18px;
                }
            }
        }

        .list {
            .list-box {
                padding: 12px;
                margin-bottom: 12px;
                background: #fff;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
                align-items: flex-start;

                .list-box-l img {
                    width: 40px;
                    height: 40px;
                }

                .list-box-c {
                    width: auto;
                    flex: 1;
                    min-width: 0;
                    padding: 0 8px;

                    .text-18 {
                        font-size: 15px;
                        line-height: 1.4;
                    }

                    .text-14 {
                        font-size: 13px;
                        line-height: 1.4;
                        word-break: break-all;
                    }
                }

                .list-box-time {
                    flex-shrink: 0;
                    font-size: 12px;
                    line-height: 1.4;
                    max-width: 72px;
                    text-align: right;
                }

                &.justify-between {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 8px;

                    .list-box-c {
                        padding: 0;
                    }

                    .list-box-time {
                        max-width: none;
                        text-align: left;
                    }
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/ShortcutBar/news.vue